

import { useState } from "react"

import bg1 from '../assets/images/backgrounds/rentic_bg_element1.svg';
import bg3 from '../assets/images/backgrounds/rentic_bg_element3.svg';
import { Label } from "../components/form/Label"
import { Input } from "../components/form/Input"
import { PrimaryButton } from "../components/buttons/PrimaryButton"

import { EmailSentResponse, sendContactMail } from "../api/requests/contact";
import { ContactForm } from "../api/requests/interfaces/ContactForm";
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { SpinnerContainer } from "../components/common/SpinnerContainer";
import { Helmet } from "react-helmet-async";

export const ContactPage: React.FC = () => {

    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [message, setMessage] = useState<string>("");

    const [nameInvalid, setNameInvalid] = useState<boolean>(false);
    const [emailInvalid, setEmailInvalid] = useState<boolean>(false);
    const [messageInvalid, setMessageInvalid] = useState<boolean>(false);

    const [emailSuccess, setEmailSuccess] = useState<boolean | undefined>();

    const [loading, setLoading] = useState<boolean>(false);

    const validateEmail = (email: string) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };


    const handleSubmit = async (useFilters = true) => {



        setNameInvalid(false);
        setEmailInvalid(false);
        setMessageInvalid(false);

        let invalid = false;

        if (!name.length) {
            setNameInvalid(true);
            invalid = true;
        }
        if (!message.length) {
            setMessageInvalid(true);
            invalid = true;
        }
        if (!validateEmail(email)) {
            setEmailInvalid(true);
            invalid = true;
        }
        if (invalid) { return }

        setLoading(true);

        const data: ContactForm = {
            name: name,
            email: email,
            message: message
        }

        const res = await sendContactMail(data);

        if (res.data.success) {
            setEmailSuccess(true);
            setName("");
            setEmail("");
            setMessage("");
        } else {
            setEmailSuccess(false);
            setName("");
        }

        setLoading(false);
    }

    return (
        <div className="w-full h-full flex justify-center items-center overflow-hidden p-4">

            <Helmet>
                <title>Rentic - Kontakt</title>
                <meta name="description" content="Mure või ettepanek? Võta ühendust Renticu tiimiga." />
                <meta name="keywords" content="rentic, kontakt, Rentic" />
                <meta property="og:title" content="Rentic - Kontakt" />
                <meta property="og:description" content="Mure või ettepanek? Võta ühendust Renticu tiimiga." />
                <meta property="og:image" content="/logo512.png" />
                <meta property="og:url" content="https://rentic.ee/contact" />
            </Helmet>

            <img className="absolute top-0 left-0 h-[90%] opacity-35 w-auto pointer-events-none" src={bg1} alt="Background 1" />
            <img className="absolute top-0 right-0 h-[50%] opacity-25 object-contain object-top w-auto pointer-events-none" src={bg3} alt="Background 2" />

            <div className="w-full flex flex-col z-10 mt-[60px] pb-10 justify-center items-center">

                <div className="w-full lg:w-[550px]">
                    <SpinnerContainer show={loading}>
                        <div className="flex flex-col gap-3 w-full shadow-main bg-white rounded-xl p-10">

                            <h2 className="text-primary text-left font-semibold pb-3">Võta ühendust</h2>

                            <Input value={name} onChange={(e) => setName(e)} placeHolder="Nimi" name="name" invalid={nameInvalid} />
                            <Input value={email} onChange={(e) => setEmail(e)} placeHolder="E-post" name="email" invalid={emailInvalid} />
                            <textarea
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="Sõnum"
                                className={`${messageInvalid ? "border-red-500 border-[1px]" : ""} w-full h-[120px] border border-gray-300 p-3 rounded-lg`}
                            />

                            <div className="flex max-w-[140px] pt-3 items-center">
                                <PrimaryButton title={"Saada"} onClick={handleSubmit} />
                            </div>
                            {emailSuccess ?
                                <div className="flex flex-row gap-2 text-green-600 text-left">
                                    <CheckOutlinedIcon />
                                    Kiri edukalt saadetud!
                                </div> : emailSuccess === false &&
                                <div className="flex flex-row gap-2 text-red-600 text-left">
                                    <ErrorOutlineOutlinedIcon />
                                    Kirja saatmine ebaõnnestus. Kirjuta meile: info@rentic.ee
                                </div>
                            }

                        </div>

                    </SpinnerContainer>
                </div>
            </div>
        </div>
    )
}